// src/redux/slices/walletSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchWalletBalance = createAsyncThunk(
  'wallet/fetchBalance',
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = localStorage.getItem('authToken');
      const merchantId = localStorage.getItem('merchantId');
      if (!token || !merchantId) throw new Error('Missing auth');
      const res = await axios.get(
        `${process.env.REACT_APP_OMS_BASE_URL}/v1/wallet/${merchantId}/balance`,
        { headers: { Authorization: token } }
      );
      return res.data; 
    } catch (e) {
      return rejectWithValue(e?.response?.data || 'Failed to fetch balance');
    }
  }
);

const walletSlice = createSlice({
  name: 'wallet',
  initialState: {
    balance: null,
    type: null,
    status: 'idle',
    lastUpdated: 0,
    error: null,
  },
  reducers: {
    applyDelta(state, { payload }) {
      if (typeof state.balance === 'number') {
        state.balance = Math.max(0, state.balance + payload);
        state.lastUpdated = Date.now();
      }
    },
    setBalance(state, { payload }) {
      state.balance = payload.balance;
      state.type = payload.type ?? state.type;
      state.lastUpdated = Date.now();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWalletBalance.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchWalletBalance.fulfilled, (state, { payload }) => {
        state.status = 'succeeded';
        state.balance = payload?.total_available_balance ?? state.balance;
        state.type = payload?.type ?? state.type;
        state.lastUpdated = Date.now();
        state.error = null;
      })
      .addCase(fetchWalletBalance.rejected, (state, { payload }) => {
        state.status = 'failed';
        state.error = payload || 'Failed';
      });
  },
});

export const { applyDelta, setBalance } = walletSlice.actions;
export default walletSlice.reducer;
